export interface UIState {
  // Count of in-flight HTTP requests; > 0 drives the global loader.
  activeRequests: number;
  errorMessage: string | null;
  successMessage: string | null;
}

export const initialUiState: UIState = {
  activeRequests: 0,
  errorMessage: null,
  successMessage: null,
};
